// removed by extract-text-webpack-plugin
module.exports = {"button":"j4TbR","icon":"_236tj","isHighlighted":"-RCjA","iconHover":"_3EwDE","background":"rt_4x"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-button.scss
// module id = 700
// module chunks = 3 4 5 6 7